/**
 * Loads the icon sprite asynchronously and injects it into the DOM
 * This improves caching and reduces the size of the generated HTML page
 */
let iconSpriteLoadPromise = null;

export function loadIconSprite() {
	// Return existing promise if already loading/loaded
	if (iconSpriteLoadPromise) {
		return iconSpriteLoadPromise;
	}

	// Check if sprite is already in DOM
	const existingSprite = document.querySelector('.js-icon-sprite');
	if (existingSprite && existingSprite.querySelector('symbol')) {
		iconSpriteLoadPromise = Promise.resolve();
		return iconSpriteLoadPromise;
	}

	// Create promise to load sprite
	iconSpriteLoadPromise = fetch('/icons/icon-sprite.svg')
		.then(response => {
			if (!response.ok) {
				throw new Error(`Failed to load icon sprite: ${response.statusText}`);
			}
			return response.text();
		})
		.then(svgContent => {
			// Create container if it doesn't exist
			let container = document.querySelector('.js-icon-sprite');
			if (!container) {
				container = document.createElement('div');
				container.style.display = 'none';
				container.className = 'js-icon-sprite';
				document.body.appendChild(container);
			}

			// Inject SVG content
			container.innerHTML = svgContent;

			// Dispatch event for components that need to know when sprite is loaded
			window.dispatchEvent(new CustomEvent('iconSpriteLoaded'));
		})
		.catch(error => {
			console.error('Error loading icon sprite:', error);
			iconSpriteLoadPromise = null; // Reset promise on error so it can be retried
			throw error;
		});

	return iconSpriteLoadPromise;
}

// Auto-load sprite if DOM is ready, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		loadIconSprite();
	});
} else {
	loadIconSprite();
}
